/** @jsx jsx */
import { Button, ButtonGroup, Classes, IButtonGroupProps, Menu, MenuItem, Popover } from '@blueprintjs/core';
import { css, jsx } from '@emotion/react';
import { Dispatch, SetStateAction } from 'react';
import { overflowEllipsis } from 'styles/styledComponentUtils';

export type FacetSortOption = {
	value: string;
	label: string;
}

export enum FACET_SORT_ENUM {
	NUMERIC = "NUMERIC",
	ALPHABETICAL = "ALPHABETICAL",
}
export const SORT_TYPES: {[key in string]: FacetSortOption } = {
	[FACET_SORT_ENUM.NUMERIC]: { value: 'count', label: 'Count' },
	[FACET_SORT_ENUM.ALPHABETICAL]: { value: 'alphabetical', label: 'Name' },
};

interface Props<> extends IButtonGroupProps {
	sortOptions?: string[],
	selectedSortOption?: string,
	setSelectedSortOption?: Dispatch<SetStateAction<string>>,
	isDescending?: boolean,
	setIsDescending?: Dispatch<SetStateAction<boolean>>,
	label?: string,
}

export const SortSelect: React.FC<Props> = ({
	sortOptions = [],
	selectedSortOption,
	setSelectedSortOption,
	isDescending = true,
	setIsDescending,
	label = 'Sort:',
	...props
}) => {

	// STATELESS //

	return (
		<ButtonGroup
			minimal
			className={Classes.SMALL}
			css={buttonGroupStyle}
			{...props}
		>
			<Popover
				css={popoverStyle}
				content={
					<Menu>
						{sortOptions.map((option, i) => (
							<MenuItem
								key={option}
								text={option}
								onClick={() => {
									setSelectedSortOption(option)
									setIsDescending && setIsDescending(true)
								}}
								active={option == selectedSortOption}
							/>
						))}
					</Menu>
				}
			>
				<Button
					css={sortButtonStyle}
					small
					fill
				>
					<strong>{label}</strong>{` `}
					<span>{selectedSortOption || 'None'}</span>

				</Button>
			</Popover>
			{setIsDescending && (
				<Button
					icon={isDescending ? 'sort-desc' : 'sort-asc'}
					cy-test={`docket-list-${isDescending ? 'sort-desc' : 'sort-asc'}`}
					onClick={() => setIsDescending(!isDescending)}
					small
				/>
			)}
		</ButtonGroup>
	);
};

const buttonGroupStyle = css`
	overflow: hidden;
`;

const sortButtonStyle = css`
 flex: 1 1 auto;
 .${Classes.BUTTON_TEXT}{
	 ${overflowEllipsis}
 }
`

const popoverStyle = css`
	&, & .${Classes.POPOVER_TARGET} {
		overflow:hidden;
	}
`

